"use strict";
exports.__esModule = true;
exports.getPublicLink = exports.getEventsOfCurrentMonth = void 0;
var tslib_1 = require("tslib");
var addMonths_1 = tslib_1.__importDefault(require("date-fns/addMonths"));
var format_1 = tslib_1.__importDefault(require("date-fns/format"));
var parseISO_1 = tslib_1.__importDefault(require("date-fns/parseISO"));
var startOfMonth_1 = tslib_1.__importDefault(require("date-fns/startOfMonth"));
var utilities_1 = require("@sportnet/utilities");
var tagmanager_connector_1 = require("@sportnet/tagmanager-connector");
var CalendarApi_1 = tslib_1.__importDefault(require("../../../api/CalendarApi"));
var setupApis_1 = require("../../../api/setupApis");
setupApis_1.setupCalendarApi();
/**
 * Returns events of current month, defined by date in `date` input variable.
 *
 * @param widget Events list widget data (dateFrom, dateTo is ignored)
 * @param date Date from which start and end of the month will be calculated.
 * @returns
 */
exports.getEventsOfCurrentMonth = function (appSpace, widget, date) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var dateFrom, dateTo, params, _i, _a, filter, response;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                dateFrom = startOfMonth_1["default"](date);
                dateTo = addMonths_1["default"](dateFrom, 1);
                params = {
                    dateFrom: format_1["default"](dateFrom, 'yyyy-MM-dd'),
                    dateTo: format_1["default"](dateTo, 'yyyy-MM-dd')
                };
                for (_i = 0, _a = widget.eventFilter || []; _i < _a.length; _i++) {
                    filter = _a[_i];
                    if (!filter.value) {
                        continue;
                    }
                    switch (filter.type) {
                        case 'calendar': {
                            if (Array.isArray(filter.value)) {
                                if (filter.value.length > 0) {
                                    params.calendarId = filter.value;
                                }
                            }
                            else {
                                params.calendarId = filter.value;
                            }
                            break;
                        }
                        case 'smarttag': {
                            if (filter.subtype === 'includes') {
                                params.smarttags = tagmanager_connector_1.smarttagsToUrl(filter.value, []);
                            }
                            break;
                        }
                        default:
                            break;
                    }
                }
                return [4 /*yield*/, CalendarApi_1["default"].getAppEventsPublic(appSpace, params)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response.events];
        }
    });
}); };
/**
 * Returns public link for calendar events.
 *
 * @param appSpace
 * @param eventFilter
 * @param events
 * @param showAsMonthlyCalendar
 * @param date
 */
exports.getPublicLink = function (appSpace, eventFilter, events, showAsMonthlyCalendar, date) {
    var linkTmp = '';
    if (appSpace && events && events.length > 0) {
        var d = void 0;
        if (showAsMonthlyCalendar) {
            d = date
                ? format_1["default"](startOfMonth_1["default"](date), 'yyyy-MM-dd')
                : format_1["default"](startOfMonth_1["default"](new Date()), 'yyyy-MM-dd');
        }
        else {
            d = format_1["default"](parseISO_1["default"](events[0].dates[0].from), 'yyyy-MM-dd');
        }
        var params_1 = {
            calendars: '',
            dateFrom: d
        };
        eventFilter.forEach(function (f) {
            if (f.type === 'calendar' && f.value) {
                params_1.calendars = f.value.join('|');
            }
        });
        linkTmp = "https://public.calendar.sportnet.online/" + appSpace + "?" + utilities_1.objectToParams(params_1);
    }
    return linkTmp;
};
